import { render } from "./ParcelsList.vue?vue&type=template&id=d80a80da&scoped=true"
import script from "./ParcelsList.vue?vue&type=script&lang=js"
export * from "./ParcelsList.vue?vue&type=script&lang=js"

import "./ParcelsList.vue?vue&type=style&index=0&id=d80a80da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d80a80da"]])

export default __exports__